export const generateAvatarSeed = (name: string): number => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    const char = name.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return Math.abs(hash);
};

export const getAvatarUrl = (name: string, size: number = 64): string => {
  const seed = generateAvatarSeed(name);
  return `https://473erq4qb3rmoel667xioyekia0xbrct.lambda-url.us-east-2.on.aws/?seed=${seed}&size=${size}`;
};